import { Link } from "react-router-dom";

const columns = [
  {
    title: "浏览作品",
    links: [
      { label: "全部参赛作品", to: "/works" },
      { label: "热门排行", to: "/works?sort=hot" },
      { label: "最多点赞", to: "/works?sort=likes" },
      { label: "最新投稿", to: "/works?sort=latest" },
    ],
  },
  {
    title: "作品方向",
    links: [
      { label: "职场爆料", to: "/works?category=workplace" },
      { label: "行业内幕", to: "/works?category=industry" },
      { label: "校园见闻", to: "/works?category=campus" },
      { label: "生活观察", to: "/works?category=life" },
    ],
  },
  {
    title: "关于大赛",
    links: [
      { label: "大赛说明", to: "/about" },
      { label: "参赛规则", to: "/about#rules" },
      { label: "赛程时间线", to: "/about#timeline" },
      { label: "投稿与咨询", to: "/about#submit" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-primary-900 text-background-100">
      <div className="h-1 w-full bg-gradient-to-r from-primary-500 via-accent-500 to-primary-500" />
      <div className="px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-md bg-accent-500 text-primary-950 flex items-center justify-center font-heading text-lg font-bold">
                爆
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-background-50">爆料大赛</span>
                <span className="font-label text-[10px] text-primary-200 tracking-[0.22em] mt-0.5">BAOLIAO OPEN</span>
              </span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-primary-100 max-w-sm">
              一个把真实观察写下来、认真读下去的参赛作品集。这里收录每一期投稿中的精选内容，让细节被更多人看见。
            </p>
            <div className="mt-6 flex items-center gap-2.5">
              {[
                { icon: "ri-wechat-line", label: "微信" },
                { icon: "ri-weibo-line", label: "微博" },
                { icon: "ri-mail-line", label: "邮箱" },
                { icon: "ri-rss-line", label: "订阅" },
              ].map((s) => (
                <span
                  key={s.label}
                  title={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-800 text-background-100 text-lg"
                >
                  <i className={s.icon} />
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {columns.map((col) => (
              <div key={col.title}>
                <h4 className="font-heading text-sm font-bold text-background-50 tracking-wide">{col.title}</h4>
                <ul className="mt-4 space-y-2.5">
                  {col.links.map((l) => (
                    <li key={l.label}>
                      <Link
                        to={l.to}
                        className="text-sm text-primary-100 hover:text-accent-300 transition-colors cursor-pointer"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <h4 className="font-heading text-sm font-bold text-background-50 tracking-wide">投稿邮箱</h4>
            <p className="mt-4 text-sm text-primary-100 leading-relaxed">
              稿件请发送至下方邮箱，或通过大赛说明页的投稿表单提交。
            </p>
            <p className="mt-4 font-label text-base text-accent-300 tracking-wide break-all">
              submit@baoliao-contest.example.com
            </p>
            <Link
              to="/about#submit"
              className="mt-5 inline-flex items-center gap-1.5 bg-accent-500 hover:bg-accent-400 text-primary-950 text-sm font-medium px-4 py-2.5 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-quill-pen-line" />
              </span>
              提交参赛作品
            </Link>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-primary-200">© 2026 爆料大赛作品集 · 内容均为参赛者投稿，不代表本站观点</p>
          <div className="flex items-center gap-5 text-xs text-primary-200">
            <Link to="/about" className="hover:text-accent-300 transition-colors cursor-pointer">
              内容规范
            </Link>
            <Link to="/about#rules" className="hover:text-accent-300 transition-colors cursor-pointer">
              参赛规则
            </Link>
            <Link to="/works" className="hover:text-accent-300 transition-colors cursor-pointer">
              作品集
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}